import React, { useEffect } from "react";
import { COLORS } from "../utils/constants";
import { useViewMode } from "../contexts/ViewModeContext";

/**
 * PositionInput component for Bar/Beat/Subdivision input
 * Used for Key Change List and Tempo List in Song-Level Annotations
 */
const PositionInput = ({ position, onChange, maxSubdivision = 4, maxBeat = 4 }) => {
  const {isViewMode} = useViewMode();

  // COMMENTED OUT: Auto-clamping subdivision when maxSubdivision changes
  // useEffect(() => {
  //   if (position.subdivision && position.subdivision > maxSubdivision) {
  //     onChange({ ...position, subdivision: maxSubdivision });
  //   }
  // }, [maxSubdivision, position.subdivision, onChange]);

  // COMMENTED OUT: Auto-clamping beat when maxBeat changes
  // useEffect(() => {
  //   if (position.beat && position.beat > maxBeat) {
  //     onChange({ ...position, beat: maxBeat });
  //   }
  // }, [maxBeat, position.beat, onChange]);

  const handleChange = (field, value) => {
    // Allow empty string to support typing single digits
    if (value === '') {
      onChange({ ...position, [field]: '' });
      return;
    }
    
    // COMMENTED OUT: Positive integer validation
    // const numValue = parseInt(value, 10);
    // if (isNaN(numValue) || numValue < 1) return;
    
    // COMMENTED OUT: Beat limit validation
    // For beat, use dynamic maxBeat limit
    // if (field === 'beat' && numValue > maxBeat) return;
    
    // COMMENTED OUT: Subdivision limit validation
    // For subdivision, use dynamic maxSubdivision limit
    // if (field === 'subdivision' && numValue > maxSubdivision) return;
    
    // Accept any numeric value
    const numValue = parseInt(value, 10);
    if (!isNaN(numValue)) {
      onChange({ ...position, [field]: numValue });
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <div>
        <label className="text-sm font-medium" style={{ color: COLORS.TEXT_SECONDARY }}>Bar</label>
        <input
          type="number"
          value={position.bar}
          onChange={(e) => handleChange('bar', e.target.value)}
          className="w-16 px-2 py-1 border border-gray-300 rounded"
          disabled={isViewMode}
        />
      </div>
      <div>
        <label className="text-sm font-medium" style={{ color: COLORS.TEXT_SECONDARY }}>Beat</label>
        <input
          type="number"
          value={position.beat}
          onChange={(e) => handleChange('beat', e.target.value)}
          className="w-16 px-2 py-1 border border-gray-300 rounded"
          disabled={isViewMode}
        />
      </div>
      <div>
        <label className="text-sm font-medium" style={{ color: COLORS.TEXT_SECONDARY }}>Subdivision</label>
        <input
          type="number"
          value={position.subdivision}
          onChange={(e) => handleChange('subdivision', e.target.value)}
          className="w-16 px-2 py-1 border border-gray-300 rounded"
          disabled={isViewMode}
        />
      </div>
    </div>
  );
};

export default PositionInput;
